import { render, staticRenderFns } from "./useAccountHistory.vue?vue&type=template&id=207110f0&scoped=true"
import script from "./useAccountHistory.vue?vue&type=script&lang=js"
export * from "./useAccountHistory.vue?vue&type=script&lang=js"
import style0 from "./useAccountHistory.vue?vue&type=style&index=0&id=207110f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207110f0",
  null
  
)

export default component.exports